import { FETCH_CARS } from '../actionTypes/cars';

const initState = {
  ids: [],
  dataById: {},
  isLoading: false,
  dataNext: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case FETCH_CARS.LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_CARS.SUCCESS: {
      const { payload, dataNext } = action;
      const ids = payload.map(car => car.id);
      const dataById = payload.reduce((accu, current) => {
        accu[current.id] = current;
        return accu;
      }, {});
      return {
        ...state,
        isLoading: false,
        ids,
        dataById,
        dataNext,
      };
    }
    case FETCH_CARS.FAIL:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
